<!-- 新生报到 -->
<template>
    <div class="el-studentReport">
        <el-row class="page_content">

            <h1 class="head_title">
                新生报到
                <span
                    v-if="!$isEmpty(registrationTime.startTime) && !$isEmpty(registrationTime.endTime) && !$strExistHostnameOnce(['hbkjxy'])"
                    style="font-size: 14px;color: #ff2626;margin-left: 20px;font-weight: 500;">
                    【 报到时间：{{ registrationTime.startTime }} 至 {{ registrationTime.endTime }} 请在规定时间内完成报到！】
                </span>
            </h1>
            <template v-if="$isEmpty(registrationTime.startTime) || $isEmpty(registrationTime.endTime)">
                <el-empty :description="descriptionMsg"></el-empty>
            </template>
            <template v-if="!$isEmpty(registrationTime.startTime) && !$isEmpty(registrationTime.endTime)">
                <el-steps v-if="showSteps" :active="active" align-center finish-status="success"
                    style="width: 1000px;margin: 0 auto;">
                    <el-step title="缴费" v-if="setUpInfo.studentNewPayConfig"></el-step>
                    <el-step title="确认信息"></el-step>
                    <el-step title="照片上传" v-if="setUpInfo.studentNewPhotoOpenConfig"></el-step>
                    <el-step title="人脸识别" v-if="setUpInfo.studentNewFaceOpenConfig"></el-step>
                    <el-step title="报到材料补充" v-if="setUpInfo.studentNewDataOpenConfig"></el-step>
                    <el-step title="报道材料审核状态" v-if="setUpInfo.studentNewDataAuditOpenConfig"></el-step>
                    <el-step title="报到完成"></el-step>
                </el-steps>
                <!-- <p style="color: red;text-align: center;margin: 0;">
                报到时间：2023-10-11 至 2023-12-11 请在规定时间内完成报到！
            </p> -->
                <el-row style="margin-top: 10px;">
                    <!-- 步骤1 -->
                    <div v-if="flowMap[active] == 'payConfig'" style="width: 500px;margin: 0 auto;">
                        <template v-if="payStatusInfo.payStatus == 2">
                            <!-- <h2 class="studentName">{{ userInfo.studentName }}</h2> -->
                            <!-- <p>函授站：{{ userInfo.corSchoolName  || "-"}}</p> -->
                            <p>姓名：{{ userInfo.studentName }}</p>
                            <p v-if="payStatusInfo.payType == 1">待缴费：<span style="color:red">￥ {{ toBePaid }}</span></p>
                            <template v-if="!$strExistHostnameOnce(['hsnc'])">
                                <p>身份证号：{{ userInfo.studentIdCard || "-" }}</p>
                            </template>
                            <template v-else>
                                <p>学号：{{ userInfo.studentNo || "-" }}</p>
                            </template>

                            <el-button type="primary" v-if="payStatusInfo.payType == 1"
                                @click="payDialogClick">去支付</el-button>
                            <el-row style="color: red;">
                                {{ payStatusInfo.payMsg }}
                            </el-row>
                        </template>
                        <template v-if="payStatusInfo.payStatus == 1">
                            <p style="color: #67C23A;text-align: center;">
                                <i class="el-icon-success"
                                    style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                                {{ payStatusInfo.payMsg }}
                            </p>
                            <el-row style="text-align: center;">
                                <el-button type="primary" @click="next" style="margin-top: 80px;">下一步</el-button>
                            </el-row>
                        </template>
                    </div>
                    <!-- 步骤2 -->
                    <div v-if="flowMap[active] == 'confirmConfig'" style="width: 1000px;margin: 0 auto;">
                        <template v-if="!$isEmpty(userInfo.studentName)">
                            <el-descriptions :colon="false" :column="2">
                                <el-descriptions-item label="姓名：">{{ userInfo.studentName }}</el-descriptions-item>
                                <el-descriptions-item label="考生号：">{{ userInfo.studentTestNo }}</el-descriptions-item>
                            </el-descriptions>
                            <el-descriptions :colon="false" :column="2">
                                <template v-if="!$strExistHostnameOnce(['hsnc'])">
                                    <el-descriptions-item label="身份证号：">{{ userInfo.studentIdCard }}
                                    </el-descriptions-item>
                                </template>
                                <template v-else>
                                    <el-descriptions-item label="学号：">{{ userInfo.studentNo }} </el-descriptions-item>
                                </template>
                                <el-descriptions-item label="性别：">{{ userInfo.studentSex == 1 ? "男" :
                                    userInfo.studentSex ==
                                        2 ? "女" : "保密" }}</el-descriptions-item>
                            </el-descriptions>
                            <!-- <template v-if="!$strExistHostnameOnce(['hsnc','hbwgy'])">
                            <el-descriptions :colon="false" :column="2">
                                <el-descriptions-item label="政治面貌：">{{userInfo.studentPoliticalOutlook}}</el-descriptions-item>
                              <el-descriptions-item label="民族：">{{userInfo.studentNation}}</el-descriptions-item>
                            </el-descriptions>
                        </template> -->
                            <el-descriptions :colon="false" :column="2">
                                <el-descriptions-item label="专业名称：">{{ userInfo.professionalName
                                    }}</el-descriptions-item>
                                <el-descriptions-item label="层次：">{{ userInfo.cultivationLevelConcat
                                    }}</el-descriptions-item>
                            </el-descriptions>
                            <el-descriptions :colon="false" :column="2">
                                <el-descriptions-item label="学习形式：">{{ userInfo.learningModalityConcat
                                    }}</el-descriptions-item>
                                <template v-if="!$strExistHostnameOnce(['hsnc', 'hbwgy', 'localhost'])">
                                    <el-descriptions-item label="学制：">{{ userInfo.professionalLength
                                        }}</el-descriptions-item>
                                </template>
                            </el-descriptions>

                            <el-row style="text-align: center;">
                                <!--1：已确认 2：待确认 3：信息有误  -->
                                <template v-if="!$strExistHostnameOnce(['hsnc', 'hbwgy', 'localhost'])">
                                    <el-button type="primary" style="margin-top: 12px;"
                                        v-if="userInfo.studentConfirm == 1" @click="next">下一步</el-button>
                                    <el-button type="primary" v-if="userInfo.studentConfirm == 2" :loading="submitBut"
                                        style="margin-top: 20px;" @click="submitInfo(1)">确认无误</el-button>
                                    <!-- @click="infoConfirm" -->
                                    <el-button type="danger" v-if="userInfo.studentConfirm == 2" :loading="submitBut"
                                        style="margin-top: 20px;" @click="infoConfirm">信息有误</el-button>
                                    <el-button type="danger" plain v-if="userInfo.studentConfirm == 3"
                                        style="margin-top: 20px;">已确认信息有误</el-button>
                                </template>
                                <template v-else>
                                    <el-button type="primary" style="margin-top: 12px;"
                                        v-if="userInfo.studentConfirm == 2 || userInfo.studentConfirm == 3"
                                        @click="submitInfo(1, 'xyb')">下一步</el-button>
                                    <el-button type="primary" style="margin-top: 12px;"
                                        v-if="userInfo.studentConfirm == 1" @click="next">下一步</el-button>
                                </template>
                            </el-row>
                        </template>
                    </div>
                    <el-dialog title="提示" :visible.sync="infoConfirmVisible" width="30%" style="margin-top: 100px;"
                        :close-on-click-modal="false">
                        <div class="infoConfirmText">如果信息有误，请联系平台老师18618337286</div>
                        <span slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="submitInfo(3)">确 定</el-button>
                        </span>
                    </el-dialog>
                    <!-- 步骤3 -->
                    <div v-if="flowMap[active] == 'dataOpenConfig'" style="width: 1000px;margin: 0 auto;">
                        <el-row style="padding-bottom:10px;">
                            <el-col :span="4" style="text-align: center;min-width:200px;">
                                新生照片预览
                            </el-col>
                            <el-col :span="4" style="min-width:200px;text-align: center;">
                                新生照片上传
                            </el-col>
                        </el-row>
                        <el-row style="padding-bottom:10px;">
                            <el-col :span="4" style="text-align: center;min-width:200px;">
                                <el-image :src="headImg" :preview-src-list="[headImg]"
                                    style="border: 1px solid #f0f0f0;width: 144px;height: 192px;" />
                            </el-col>
                            <el-col :span="4" style="min-width:200px;text-align: center;">
                                <el-upload class="avatar-uploader" :action="uploadUrl"
                                    :disabled="studentPhotoInfo.studentPhotoConfirm == 1" :headers="headers"
                                    :show-file-list="false" :on-success="handleAvatarSuccess"
                                    :before-upload="beforeAvatarUpload">
                                    <i class="el-icon-plus avatar-uploader-icon" title="点击上传"></i>
                                </el-upload>
                            </el-col>

                            <el-col :span="14" style="min-width:300px;">
                                <!-- studentPhotoConfirm:是否确认照片无误（1是 2否） -->
                                <!-- studentStatusState:状态（1已审核 2未审核 3不通过） -->
                                <p v-if='studentPhotoUrl != null && studentPhotoUrl != ""'>
                                    照片状态：
                                    <template
                                        v-if="studentPhotoInfo.studentPhotoConfirm == 2 || studentPhotoInfo.studentPhotoConfirm == null">
                                        <span style="color: #b0adad;">未确认</span>
                                        <el-button style="margin-left: 20px;" @click="confirmStudentNewPhoto"
                                            size="small" type="primary">确认照片</el-button>
                                    </template>
                                    <template v-else>
                                        <span style="color: #3967FF;"
                                            v-if="studentPhotoInfo.studentPhotoConfirm == 1">已确认无误</span>
                                    </template>
                                </p>
                                <template v-if="studentPhotoInfo.studentPhotoState != null">
                                    <p>
                                        审核状态：
                                        <span style="color: #3967FF;"
                                            v-if="studentPhotoInfo.studentPhotoState == 1">审核通过</span>
                                        <span style="color: #b0adad;"
                                            v-if="studentPhotoInfo.studentPhotoState == 2">待审核</span>
                                        <span style="color: red;"
                                            v-if="studentPhotoInfo.studentPhotoState == 3">审核未通过（请重新上传）</span>
                                    </p>
                                    <div style="color: red;"
                                        v-if="studentPhotoInfo.studentPhotoState == 3 && !$isEmpty(studentPhotoInfo.examineRemark)">
                                        审核说明：{{ studentPhotoInfo.examineRemark }}
                                    </div>
                                </template>
                            </el-col>
                        </el-row>
                        <el-row style="color:red;padding-left:50px;font-size: 12px;">
                            <p style="margin:0;">电子版图像要求：</p>
                            <p style="margin:5px  0;">1、蓝色背景，图像不大于1M；</p>
                            <p style="margin:5px  0;">2、图像“高”要求在 192 像素（px），“宽”要求在 144 像素（px）；</p>
                            <p style="margin:5px  0;">3、鉴于学生照片的严肃性，请同学务必提交标准证件照，生活照、手机拍照、以及PS、美图等工具修复的照片均不予审核通过。</p>
                        </el-row>

                        <el-row style="text-align: center;margin-top: 12px;">
                            <!-- <el-button type="primary" v-if="$isEmpty(studentPhotoUrl)" @click="addStudentNewPhoto">确认上传</el-button> -->
                            <!-- <el-button type="primary" @click="confirmStudentNewPhoto">确认无误</el-button> -->
                            <el-button type="primary" @click="next"
                                v-if="studentPhotoInfo.studentPhotoState == 1">下一步</el-button>
                        </el-row>
                    </div>
                    <!-- 步骤4 -->
                    <div v-if="flowMap[active] == 'faceOpenConfig'"
                        style="width: 1000px;margin: 0 auto;text-align: center;">
                        <template v-if="showFace == 1">
                            <p style="color: #67C23A;">
                                <i class="el-icon-success"
                                    style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                                已通过人脸识别
                            </p>
                            <el-button type="primary" @click="next" style="margin-top: 80px;">下一步</el-button>
                        </template>
                        <template v-else>
                            <!-- 人脸识别 -->
                            <template v-if="getTimeRegion(1)">
                                <newStudentFace v-if="visibleFaceModal && showFace != 1" v-show="visibleFaceModal"
                                    @successFace="successFace" :visible="visibleFaceModal" />
                            </template>
                            <template v-else>
                                <p style="color: red;margin-top: 50px;">
                                    <i class="el-icon-error"
                                        style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                                    报道时间已结束
                                </p>
                            </template>
                        </template>
                    </div>
                    <!-- 步骤5 -->
                    <div v-if="flowMap[active] == 'photoOpenConfig'" style="width: 900px;margin: 0 auto;">
                        <template v-for="(item, index) in attributeList">
                            <div
                                style="margin-bottom: 20px;border: 1px solid rgb(230 230 231);padding: 20px;box-shadow: 1px 2px 4px rgb(230 230 231);border-radius: 10px;">
                                <el-row style="padding-bottom:20px;" :key="index + 'attributeList'">
                                    <span class="title_l">
                                        <span style="color:red;" v-if="item.notNullStatus == 1">*</span>
                                        {{ item.attributeName }}：
                                    </span>
                                    <span style="float:left;margin-right:20px;"
                                        v-if="item.inputType == 6 || item.inputType == 5">
                                        <el-upload class="avatar-uploader" :action="uploadUrl" :headers="headers"
                                            :show-file-list="false"
                                            :on-success="(res, file) => { attributeSuccess(item, res, file) }"
                                            :disabled="showBut == 3"
                                            :before-upload="item.inputType == 5 ? beforeAvatarUpload : null">
                                            <template v-if="item.inputType == 5">
                                                <img v-if="!$isEmpty(attributeRelationMap[item.attributeId])"
                                                    :src="$isHttp(attributeRelationMap[item.attributeId])"
                                                    class="attrList_avatar">
                                            </template>
                                            <template v-if="item.inputType == 6">

                                                <img v-if="!$isEmpty(attributeRelationMap[item.attributeId])"
                                                    :src="filePng" class="attrList_avatar">
                                            </template>
                                            <i v-if="$isEmpty(attributeRelationMap[item.attributeId])"
                                                class="el-icon-plus attrList-uploader-icon" title="点击上传"></i>
                                        </el-upload>
                                    </span>
                                    <!-- 签名 -->
                                    <span style="float:left;margin-right:20px;" v-if="item.inputType == 9">
                                        <div style="border: 1px dashed #d9d9d9;width: 200px;height: 100px;">
                                            <img v-if="!$isEmpty(attributeRelationMap[item.attributeId])"
                                                :src="$isHttp(attributeRelationMap[item.attributeId])"
                                                class="attrList_avatar">
                                        </div>
                                    </span>
                                    <span style="float:left;margin-right:20px;">
                                        <el-button type="primary" size="small"
                                            @click="previewImg(attributeRelationMap[item.attributeId])"
                                            v-if="!$isEmpty(attributeRelationMap[item.attributeId]) && (item.inputType == 5 || item.inputType == 9)">预览</el-button>
                                        <el-button type="success" size="small"
                                            @click="cropper_cj(attributeRelationMap[item.attributeId], item.attributeId)"
                                            v-if="!$isEmpty(attributeRelationMap[item.attributeId]) && item.inputType == 5">裁剪</el-button>
                                        <el-button type="primary" size="small"
                                            @click="$downLoadFile(attributeRelationMap[item.attributeId], item.attributeName + '附件')"
                                            v-if="!$isEmpty(attributeRelationMap[item.attributeId]) && item.inputType == 6">下载</el-button>
                                        <el-button type="primary" size="small"
                                            @click="singShow(attributeRelationMap[item.attributeId], item.attributeId)"
                                            v-if="item.inputType == 9">立即签名</el-button>
                                    </span>
                                </el-row>
                                <el-row>
                                    <span class="title_l">
                                        描述：
                                    </span>
                                    <span style="float:left;margin-right:20px;width: 550px;color: #8c939d;">
                                        {{ item.attributeValues }}
                                    </span>
                                </el-row>
                            </div>
                        </template>
                        <div style="text-align: center;">
                            <el-button type="primary" style="margin-top: 12px;" v-if="showBut == 1"
                                @click="saveStudentNewData">提交资料</el-button>
                            <el-button type="primary" style="margin-top: 12px;" v-if="showBut == 2"
                                @click="saveStudentNewData('qrwu')">确认无误</el-button>
                            <!-- <template v-if="studentNewDataState == 1">
                            <el-button type="primary" style="margin-top: 12px;" v-if="showBut == 3" @click="next">下一步</el-button>
                        </template>
                        <template v-if="studentNewDataState == 2 && studentConfirmStatus == 1">
                            <el-button type="primary" plain style="margin-top: 12px;">材料已确认，等待审核中</el-button>
                        </template>
                        <template v-if="studentNewDataState == 3">
                            <span style="color: red;">审核未通过请重新上传</span>
                        </template> -->
                            <el-button type="primary" style="margin-top: 12px;" v-if="showBut == 3"
                                @click="next">下一步</el-button>
                        </div>
                    </div>
                    <!-- 步骤6 -->
                    <div v-if="flowMap[active] == 'auditPhotoOpenConfig'" style="width: 900px;margin: 0 auto;">
                        <div style="text-align: center;">
                            <template v-if="studentNewDataState == 1">
                                <p style="color: #67C23A;margin-top: 100px;">
                                    <i class="el-icon-success"
                                        style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                                    资料审核通过
                                </p>
                                <el-button type="primary" style="margin-top: 12px;" @click="next">下一步</el-button>
                                <!-- <div style="background-color: #f4f4f4;border-radius:5px;margin-top: 50px;" v-if="examineRemark != null && examineRemark != ''">
                                   <p style="text-align: left;color: red;margin: 0px auto;padding: 10px 20px;min-height: 60px;"> 审核说明：{{examineRemark}}</p>
                               </div> -->
                            </template>
                            <template v-if="studentNewDataState == 2 && studentConfirmStatus == 1">
                                <p style="color: #b1b1b1;margin-top: 100px;">
                                    <i class="el-icon-time"
                                        style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                                    材料已确认，等待审核中
                                </p>
                            </template>
                            <template v-if="studentNewDataState == 3">
                                <p style="color: red;margin-top: 100px;">
                                    <i class="el-icon-circle-close"
                                        style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                                    <span style="color: red;">审核未通过请重新上传</span>
                                </p>
                                <el-button type="primary" style="margin-top: 12px;"
                                    @click="previousStep">重新上传</el-button>
                                <div style="background-color: #f4f4f4;border-radius:5px;margin-top: 50px;">
                                    <p
                                        style="text-align: left;color: red;margin: 0px auto;padding: 10px 20px;min-height: 60px;">
                                        审核说明：{{ examineRemark }}</p>
                                </div>
                            </template>
                        </div>
                    </div>
                    <!-- 步骤7 -->
                    <div v-if="flowMap[active] == 'complete'" style="width: 1000px;margin: 0 auto;text-align: center;">
                        <p style="color: #67C23A;margin-top: 100px;" v-if="reportStatus == 1">
                            <i class="el-icon-success" style="font-size: 60px;display: block;margin-bottom: 20px;"></i>
                            新生报到完成
                        </p>
                        <div v-if="reportStatus == 2" style="margin-top: 100px;">
                            <p style="color: #67C23A;margin-bottom: 40px;">个人信息确认无误，请确认报到。</p>
                            <el-button type="primary" style="margin-top: 12px;" @click="confirmReport">确认报到</el-button>
                        </div>
                    </div>
                </el-row>
            </template>

        </el-row>

        <el-dialog title="" :visible.sync="previewImgShow" :show-close="false" class="previewImg" width="500px"
            :before-close="handleClose">
            <img :src="$isHttp(previewImgUrl)" style="max-width: 100%;" />
            <span slot="footer" class="dialog-footer" style="display: none;">
                <el-button @click="previewImgShow = false">取 消</el-button>
                <el-button type="primary" @click="previewImgShow = false">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="pay_dialog.title" :visible.sync="pay_dialog.visible" class="payDialog" width="600px">
            <el-row>
                <el-col :offset="2">
                    <span class="spanTitle">支付金额</span>
                    <span class="money">￥{{ toBePaid }}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :offset="2">
                    <span class="spanTitle">支付订单号</span>
                    <span>{{ payId }}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :offset="2">
                    <div class="typeBox">
                        <span class="spanTitle">支付方式</span>
                        <img src="../../assets/wechat.png" alt=""
                            :class="pay_dialog.payType == 'wechat' ? 'selected' : ''" @click="changePayType('wechat')">
                        <!-- <img src="../../assets/alipay.png" alt="" :class="pay_dialog.payType == 'alipay' ? 'selected' : ''"
                            @click="changePayType('alipay')"> -->
                    </div>
                </el-col>
            </el-row>
            <el-dialog width="500px" :visible.sync="pay_dialog.inner_dialog.visible" append-to-body
                class="payInnerDialog">
                <div slot="title" class="dialog-title" style="display: flex;align-items: center">
                    <img :src="pay_dialog.payType === 'wechat' ? require('../../assets/wechat.png') : require('../../assets/alipay.png')"
                        alt="">
                    <span style="margin-left: 1em">{{ pay_dialog.inner_dialog.title }}</span>
                </div>
                <div v-if="pay_dialog.payType === 'wechat'" id="qrcode" ref="qrcode"
                    style="border: none;margin-left: 50%;transform: translateX(-50%)"></div>
                <iframe v-else :src="pay_dialog.inner_dialog.imgSrc" width="200px" height="210px"
                    style="border: none;margin-left: 50%;transform: translateX(-50%)"></iframe>
                <p class="tip" style="color:red;text-align: center;padding-bottom: 20px;">请使用微信App扫码支付 ￥{{ toBePaid }}</p>
            </el-dialog>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click="pay_dialog.visible = false">关 闭</el-button>
                <el-button type="primary" @click="goPay">立即支付</el-button>
            </div>
        </el-dialog>
        <!-- 截图 -->
        <Cropper :initialImg="imageUrl" v-if="cropperShow" :key="onDataTime" :isShow="cropperShow"
            @retUrl="getPropsUrl" />

        <!-- 签名 -->
        <singDiv v-if="visible_sign" :visible="visible_sign" @closeMsg="closeMsg" @signValue="saveSignValue"></singDiv>
    </div>
</template>

<script>
import { getCookieForRoleTag, getStudentInfoKeyForRoleTag } from "../../common/ulit";
import headImg from '@/images/user/headImg.png';
import newStudentFace from "@/components/newStudentFace";	//人脸识别
import filePng from '@/images/checkInMaterials/fileInfo.png';
import QRCode from 'qrcodejs2';
import android from '@/images/login/android_cj.png';
import singDiv from "@/components/singDiv"; //签名
import {
    getOnlinePrice,
    downloadPayList,
    getWeChatPayQRCode,
    getAliPayQRCode,
    createPayId,
    getPayList
} from "../../common/services";
import Cropper from '@/components/cropper/index';
export default {
    name: "StudentReport",
    components: {
        newStudentFace,
        Cropper,
        singDiv
    },
    data() {
        return {
            infoConfirmVisible: false,//确认信息有误弹窗
            imageUrl: android, // 上传图片地址
            cropOption: {  // 如果只是单组件使用的话，可以直接写在cropper组件中，这里是多组件使用，如：头像上传，广告上传，头像与广告的上传框宽高不一样，还有查看弹窗禁用上传功能等
                autoCropWidth: '',
                autoCropHeight: '',
                width: 448,
                deleteLeft: 230,
                updateLeft: 180,
                disabled: false
            },
            userInfo: {},
            submitBut: false,
            active: 0,
            yzmType: 2,
            headImg: headImg,
            studentPhotoUrl: "",
            uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
            // headers: {token:this.$cookies.get("JT_S_02_token")}, //请求头
            headers: { token: getCookieForRoleTag(), "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null }, //请求头
            dataInfo: {},
            visibleFaceModal: false,
            setUpInfo: {//新生报到个步骤是否显示
                studentNewPhotoOpenConfig: false,  //获取新生照片上传是否打开配置
                studentNewFaceOpenConfig: false, //获取新生人脸是否打开配置
                studentNewPayConfig: false,	//获取新生缴费是否开启
                studentNewDataOpenConfig: false   //获取新生报到材料是否开启
            },
            payStatusInfo: {
                payStatus: "",  //1已缴费  2未交费
                payMsg: ""    //如果是1已缴费的时候，你可以显示这里面的消息到缴费页面
            },
            flowMap: {}, //流程map
            showSteps: false, //是否显示步骤
            loading: null,
            studentPhotoInfo: {}, //新生照片对象
            showFace: 0, //识别过了返回1，没有则返回0
            attributeList: [], //报到材料补充
            attributeRelationMap: {}, //报到资料上传值map
            filePng: filePng,
            previewImgUrl: "",
            previewImgShow: false,
            showBut: 0, //显示保存或者确认无误 1：显示保存 2：显示确认无误 3:下一步
            studentConfirmStatus: 2, //是否确认资料无误（1是 2否）
            studentNewDataState: 2, //状态（1已审核 2未审核 3不通过）
            examineRemark: "", //审核备注
            reportStatus: 2,//1 已报到 2:未报到
            registrationTime: { //获取报到时间范围
                startTime: "",
                endTime: ""
            },
            // 支付
            pay_dialog: {
                visible: false,
                title: "选择支付方式",
                payType: "wechat",
                inner_dialog: {
                    imgSrc: "",
                    visible: false,
                    title: "微信支付",
                }
            },
            toBePaid: 0, //缴费金额
            payId: "",//支付订单号
            payStatusTimeout: null,
            totalIndex: 0, //流程总步骤
            descriptionMsg: "管理员未设置新生报到时间",
            getNowTime: "", //服务器时间

            //图片裁剪
            cropperShow: false,
            onDataTime: new Date().getTime(),
            onAttributeId: null, //当前选择剪切的图片位置id,  签名的位置

            visible_sign: false,
        };
    },
    created() {
        this.getRegistrationTime();

    },
    methods: {
        payDialogClick() {
            // 判断当前时间如果不在 registrationTime.startTime , registrationTime.endTime 之间，提示未开放报到
            let nowTime = new Date().getTime();
            let startTime = new Date(this.registrationTime.startTime).getTime();
            let endTime = new Date(this.registrationTime.endTime).getTime();
            if (nowTime < startTime || nowTime > endTime) {
                this.$message({
                    message: '报到时间还未开始',
                    type: 'warning'
                });
            } else {
                this.pay_dialog.visible = true;
            }



        },
        getPropsUrl(data) { //传图片地址回来
            this.attributeRelationMap[this.onAttributeId] = data;
            this.attributeRelationMap = Object.assign({}, this.attributeRelationMap);
            if (this.showBut == 2) {
                this.saveStudentNewData();
            }
        },
        changePayType(type = 'wechat') {
            this.pay_dialog.payType = type;
            this.pay_dialog.inner_dialog.imgSrc = "";
        },
        getWeChatQrcode(text) {
            this.$refs.qrcode.innerHTML = "";
            return new QRCode('qrcode', {
                width: 200, // 设置宽度，单位像素
                height: 200, // 设置高度，单位像素
                text,   // 设置二维码内容或跳转地址
            })

        },
        async goPay() {
            const originDialog = this.pay_dialog;
            const originInnerDialog = originDialog.inner_dialog;
            const payType = originDialog.payType;
            this.pay_dialog.inner_dialog = {
                ...originInnerDialog,
                visible: true,
                title: payType === 'wechat' ? '微信支付' : '支付宝支付'
            }
            const imgPath = await this.getPayQRCode(payType);
            console.log('获取到的图片地址', imgPath);
            this.pay_dialog.inner_dialog.imgSrc = imgPath;
        },
        async getPayQRCode(type = 'wechat') {
            //支付宝直接获取地址展示，微信获取到之后要将文本转成二维码
            const fn = type === 'wechat' ? getWeChatPayQRCode : getAliPayQRCode;
            const res = await fn(this.payId);
            //区分微信、支付宝
            if (type == 'wechat') {
                const prefix = window.configs.API_ROOT;
                // let obj = {
                //     baseUrl: prefix,
                //     orderNo: this.payId,
                //     studentId: this.userInfo.studentId,
                //     studentName: this.userInfo.studentName,
                //     studentIdCard: this.userInfo.studentIdCard,
                //     studentNo: this.userInfo.studentNo,
                //     studentTestNo: this.userInfo.studentTestNo,
                //     professionalName: this.userInfo.professionalName,
                //     toBePaid: this.toBePaid,
                //     deviceType:'PC',
                // }
                let obj = {
                    price: this.toBePaid,
                    baseUrl: prefix,
                    payId: this.payId,
                    studentId: this.userInfo.studentId
                }
                const params = JSON.stringify(obj)
                const imgPath = this.getWeChatQrcode(`${prefix}/api/student/wxLogin.do?params=${params}`);
                console.log(imgPath)
                return "";
            } else {
                return res.data;
            }
        },
        getRegistrationTime() { //获取报到时间范围
            this.$store.dispatch("user/getRegistrationTime").then((ret) => {
                if (ret.code == 0) {
                    this.registrationTime = ret.data;
                    if (!this.$isEmpty(ret.data) && !this.$isEmpty(this.registrationTime.startTime) && !this.$isEmpty(this.registrationTime.endTime)) {
                        this.getStudentReportFlowConfig();
                        this.getNowDate();
                    }
                }
            }).catch((res) => {

            });
        },
        getReportStatus() { //获取报道状态
            this.$store.dispatch("user/getReportStatus").then((ret) => {
                if (ret.code == 0) {
                    this.reportStatus = ret.data;//1 已报到 2:未报到
                    if (this.reportStatus == 1) {
                        this.active = this.totalIndex;
                    } else {
                        this.getStudentNewInfo();
                        if (this.setUpInfo.studentNewPayConfig) { //新生缴费是否开启
                            this.getStudentPayStatus();

                            this.payStatusTimeout = setInterval(() => { //轮训获取支付状态。
                                this.getPayStatusTimeout();
                            }, 3500);
                        }
                    }

                }
            }).catch(() => {

            });
        },
        getStudentReportFlowConfig() { //获取新生报到各个流程的开关配置
            this.loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/getStudentReportFlowConfig").then((ret) => {
                if (ret.code == 0) {
                    this.setUpInfo = ret.data;
                    this.totalIndex = 0;
                    for (let i = 0; i < Object.keys(this.setUpInfo).length; i++) {
                        if (i == 0 && this.setUpInfo.studentNewPayConfig) {
                            this.flowMap[this.totalIndex] = "payConfig";
                            this.totalIndex++;
                            this.flowMap[this.totalIndex] = "confirmConfig";
                            this.totalIndex++;
                        } else if (i == 0 && !this.setUpInfo.studentNewPayConfig) {
                            this.flowMap[this.totalIndex] = "confirmConfig";
                            this.totalIndex++;
                        }

                        if (i == 1 && this.setUpInfo.studentNewPhotoOpenConfig) {
                            this.flowMap[this.totalIndex] = "dataOpenConfig";
                            this.totalIndex++;
                        } else if (i == 2 && this.setUpInfo.studentNewFaceOpenConfig) {
                            this.flowMap[this.totalIndex] = "faceOpenConfig";
                            this.totalIndex++;
                        } else if (i == 3 && this.setUpInfo.studentNewDataOpenConfig) {
                            this.flowMap[this.totalIndex] = "photoOpenConfig";
                            this.totalIndex++;
                        } else if (i == 4 && this.setUpInfo.studentNewDataAuditOpenConfig) { //材料审核
                            this.flowMap[this.totalIndex] = "auditPhotoOpenConfig";
                            this.totalIndex++;
                        }
                    }
                    this.flowMap[this.totalIndex] = "complete";
                    this.showSteps = true;
                    this.loading.close();
                    this.getReportStatus();
                } else {
                    this.loading.close();
                }
            }).catch(() => {
                this.loading.close();
            });
        },
        getStudentPayStatus() { //获取缴费状态
            this.$store.dispatch("user/getStudentPayStatus").then((ret) => {
                this.loading.close();
                if (ret.code == 0) {
                    this.payStatusInfo = ret.data;
                    if (this.payStatusInfo.payStatus == 2) { //1已缴费  2未交费
                        if (this.payStatusInfo.payType == 1) { //1:在线缴费 2：线下本地缴费
                            this.getPayAmount();

                            createPayId().then(res => { //未交费，获取支付订单号
                                this.payId = res.data;
                            });
                        }
                    } else {
                        if (this.payStatusTimeout != null) { //停止支付状态轮训
                            clearInterval(this.payStatusTimeout);
                        }
                    }
                }
            }).catch(() => {
                this.loading.close();
            });
        },
        getPayStatusTimeout() { //用于轮训查询缴费状态
            this.$store.dispatch("user/getStudentPayStatus").then((ret) => {
                if (ret.code == 0) {
                    this.payStatusInfo = ret.data;
                    if (this.payStatusInfo.payStatus == 1 && this.payStatusTimeout != null) { //1已缴费  2未交费
                        this.pay_dialog.visible = false;
                        this.pay_dialog.inner_dialog.visible = false;
                        clearInterval(this.payStatusTimeout);
                    }
                }
            }).catch(() => {

            });
        },
        getPayAmount() { //显示缴费金额
            this.$store.dispatch("user/getPayAmount").then((ret) => {
                this.loading.close();
                if (ret.code == 0) {
                    this.toBePaid = ret.data;
                }
            }).catch(() => {
                this.loading.close();
            });
        },
        getStudentNewInfo() { //获取新生信息【个人信息确认】
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/getStudentNewInfo").then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.userInfo = ret.data;
                } else {
                    this.$message({
                        message: ret.msg,
                        type: 'warning'
                    });
                }
            }).catch(() => {
                loading.close();
            });
        },
        getStudentNewPhoto() { //获取新生照片信息
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/getStudentNewPhoto").then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.studentPhotoInfo = ret.studentPhoto || {};
                    if (!this.$isEmpty(ret.studentPhoto.studentPhotoUrl)) {
                        this.headImg = this.$isHttp(ret.studentPhoto.studentPhotoUrl);
                        this.studentPhotoUrl = ret.studentPhoto.studentPhotoUrl;
                    }
                    this.studentPhotoInfo = Object.assign({}, this.studentPhotoInfo);
                } else {
                    this.$message({ message: ret.msg, type: 'warning' });
                }
            }).catch(() => {
                loading.close();
            });
        },
        addStudentNewPhoto() { //保存上传学生图片
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/addStudentNewPhoto", { studentPhotoUrl: this.studentPhotoUrl }).then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.studentPhotoInfo.studentPhotoState = 2;// 1已审核 2未审核 3不通过
                    this.studentPhotoInfo = Object.assign({}, this.studentPhotoInfo);
                } else {
                    this.$message({ message: ret.msg, type: 'warning' });
                }
            }).catch(() => {
                loading.close();
            });
        },
        confirmStudentNewPhoto() { //确认无误
            if (!this.getTimeRegion()) {
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/confirmStudentNewPhoto").then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.studentPhotoInfo.studentPhotoConfirm = 1;//是否确认照片无误（1是 2否）
                    this.$message.success("确认成功！");
                    this.studentPhotoInfo = Object.assign({}, this.studentPhotoInfo);
                    this.getStudentNewPhoto();
                } else {
                    this.$message({ message: ret.msg, type: 'warning' });
                }
            }).catch(() => {
                loading.close();
            });
        },
        getStudentNewFaceInfo() { //获取新生人脸识别状态，识别过了返回1，没有则返回0
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/getStudentNewFaceInfo").then((ret) => {
                loading.close();
                if (ret.code == 0) { //识别过了返回1，没有则返回0
                    this.showFace = ret.data;
                    if (ret.data == 0) {
                        this.visibleFaceModal = true;
                    }
                } else {
                    this.$message({ message: ret.msg, type: 'warning' });
                }
            }).catch(() => {
                loading.close();
            });
        },
        successFace() {
            this.showFace = 1;
        },
        getStudentNewDataNew(tag) { //获取报到材料字段以及确认状态，填写情况
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/getStudentNewData").then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.attributeList = ret.data.attributeList || [];
                    this.showBut = 1;
                    for (let i in this.attributeList) {
                        if (!this.$isEmpty(this.attributeList[i].attributeRelation)) {
                            this.showBut = 2;
                        }
                        let attributeRelation = this.attributeList[i].attributeRelation;
                        if (attributeRelation != null) {
                            this.attributeRelationMap[this.attributeList[i].attributeId] = attributeRelation.value;
                        } else {
                            this.attributeRelationMap[this.attributeList[i].attributeId] = "";
                        }
                    }
                    if (ret.data.studentConfirmStatus == 1) { //是否确认资料无误（1是 2否）
                        this.showBut = 3;
                    }
                    this.studentConfirmStatus = ret.data.studentConfirmStatus;//是否确认资料无误（1是 2否）
                    this.studentNewDataState = ret.data.studentNewDataState;//状态（1已审核 2未审核 3不通过）
                    if (this.studentNewDataState == 3) {
                        this.showBut = 3;
                    }
                    this.examineRemark = ret.data.examineRemark;//审核备注
                    this.attributeRelationMap = Object.assign({}, this.attributeRelationMap);
                    if (tag == 'cxsc') {
                        this.showBut = 2;
                    }
                } else {
                    this.$message({ message: ret.msg, type: 'warning' });
                }
            }).catch(() => {
                loading.close();
            });
        },
        handleAvatarSuccess(res, file) { //上传成功回调
            this.studentPhotoUrl = res.data.url; //准考证照片
            this.headImg = this.$baseUrl + res.data.url;
            this.addStudentNewPhoto();
        },
        beforeAvatarUpload(file) {
            if (!this.getTimeRegion()) {
                return false;
            }
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isLt5M = file.size / 1024 / 1024 <= 10;

            if (!isJPG && !isPNG) {
                this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                return false;
            }
            if (!isLt5M) {
                this.$message.error('上传头像图片大小不能超过 10MB!');
                return false;
            }
            return (isJPG || isPNG) && isLt5M;
        },
        attributeSuccess(item, res, file) { //上传成功回调 【报到资料】
            // this.headImg = this.$baseUrl + res.data.url;
            this.attributeRelationMap[item.attributeId] = res.data.url; //写入map
            this.attributeRelationMap = Object.assign({}, this.attributeRelationMap);
            if (this.showBut == 2) {
                this.saveStudentNewData();
            }
        },
        saveStudentNewData(tag) { //保存新生报到材料
            if (!this.getTimeRegion()) {
                return;
            }
            let attributeRelationList = [], status = false, msg = "";
            for (let i in this.attributeList) {
                if (this.attributeList[i].notNullStatus == 1 && this.$isEmpty(this.attributeRelationMap[this.attributeList[i].attributeId])) { //是否必填 1是 2否
                    status = true;
                    msg = "请上传" + this.attributeList[i].attributeName + "！";
                    break;
                }
            }
            if (status) {
                this.$message.warning(msg);
                return;
            }
            for (let key in this.attributeRelationMap) {
                attributeRelationList.push({
                    attributeIds: key,
                    value: this.attributeRelationMap[key],
                });
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/saveStudentNewData", { attributeRelationList: attributeRelationList }).then((ret) => {
                loading.close();
                if (tag == 'qrwu') {
                    this.confirmStudentNewData();
                } else {
                    if (ret.code == 0) {
                        this.$message.success("提交成功！");
                        this.showBut = 2;
                    } else {
                        this.$message({ message: ret.msg, type: 'warning' });
                    }
                }

            }).catch(() => {
                loading.close();
            });
        },
        confirmStudentNewData() { //确认报到材料无误
            if (!this.getTimeRegion()) {
                return;
            }
            this.$confirm('是否确认报到材料无误?确认后将无法修改', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$store.dispatch("user/confirmStudentNewData").then((ret) => {
                    loading.close();
                    if (ret.code == 0) {
                        this.$message.success("材料确定成功！");
                        this.studentNewDataState == 2;
                        this.studentConfirmStatus == 1;
                        this.showBut = 3;
                    } else {
                        this.$message({ message: ret.msg, type: 'warning' });
                    }
                }).catch(() => {
                    loading.close();
                });
            }).catch(() => {

            });
        },
        next() {
            if (this.active++ > 7) {
                this.active = 0;
            };
            // if(this.flowMap[this.active] == 'confirmConfig'){ //确认信息
            //     this.getStudentNewInfo();
            // }
            if (this.flowMap[this.active] == 'dataOpenConfig') { //照片上传
                this.getStudentNewPhoto();
            }
            if (this.flowMap[this.active] == 'faceOpenConfig') { //人脸识别
                this.getStudentNewFaceInfo();
            }
            if (this.flowMap[this.active] == 'photoOpenConfig') { //报到材料补充
                this.getStudentNewDataNew();
            }
            if (this.flowMap[this.active] == 'auditPhotoOpenConfig') { //报到材料审核状态
                this.getStudentNewDataNew();
            }
        },
        previousStep() { //重新上传
            this.active = this.active - 1;
            this.getStudentNewDataNew('cxsc');
        },
        previewImg(url) { //预览
            this.previewImgShow = true;
            this.previewImgUrl = url;
        },
        handleClose() {
            this.previewImgShow = false;
        },
        confirmReport() { //确认报到
            if (!this.getTimeRegion()) {
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/confirmReport").then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.$message.success("报到完成！");
                    this.getReportStatus();
                } else {
                    this.$message({ message: ret.msg, type: 'warning' });
                }
            }).catch(() => {
                loading.close();
            });
        },
        infoConfirm() {
            if (!this.getTimeRegion()) {
                return;
            }
            this.infoConfirmVisible = true
        },
        submitInfo(sign, tag) {
            if (!this.getTimeRegion()) {
                return;
            }
            this.submitBut = true;
            let param = {
                studentNewId: this.userInfo.studentNewId,
                studentConfirm: sign //1确认无误，2未确认
            }
            this.$store.dispatch("user/confirmStudentNewInfo", param)
                .then((ret) => {
                    this.submitBut = false;
                    if (ret.code == 0) {
                        this.userInfo.studentConfirm = sign;
                        this.infoConfirmVisible = false
                        if (tag == 'xyb') {
                            this.next();
                        } else {
                            this.$message({ message: ret.msg, type: ret.code == 0 ? 'success' : 'warning' });
                        }
                    }
                }).catch(() => {
                    this.submitBut = false;
                });
        },
        getTimeRegion(mes) { //判断当前时间是否是可报到时间段
            if (!this.$isEmpty(this.registrationTime.startTime) && !this.$isEmpty(this.registrationTime.endTime)) {
                if (this.$compareTime(this.getNowTime, this.registrationTime.startTime)) {
                    if (mes != 1) {
                        this.$message.error("报到时间还未开始");
                    }
                    return false;
                } else if (this.$compareTime(this.registrationTime.endTime, this.getNowTime)) {
                    if (mes != 1) {
                        this.$message.error("报到时间已结束");
                    }
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        getNowDate() {
            this.$store.dispatch("getNowTime").then((res) => {
                if (res.code == 0) {
                    this.getNowTime = res.data;
                }
            })
        },
        cropper_cj(url, id) { //裁剪图片
            this.onDataTime = new Date().getTime()
            this.cropperShow = true;
            this.imageUrl = this.$isHttp(url);
            this.onAttributeId = id;
        },
        singShow(url, id) {
            this.onAttributeId = id;
            this.visible_sign = true;
        },
        closeMsg() {
            this.visible_sign = false;
        },
        saveSignValue(data) { //签名的url地址
            this.attributeRelationMap[this.onAttributeId] = data;
            this.attributeRelationMap = Object.assign({}, this.attributeRelationMap);
            if (this.showBut == 2) {
                this.saveStudentNewData();
            }
        }
    },
    beforeDestroy() { //销毁前执行
        if (this.payStatusTimeout != null) { //停止支付状态轮训
            clearInterval(this.payStatusTimeout);
        }
    }
};
</script>
<style lang="less">
@import '../../styles/base.less';

.infoConfirmText {
    text-align: center;
}

.el-studentReport {
    .page_content {
        padding: 0 20px 20px;
    }

    .el-descriptions-item__label {
        white-space: nowrap;
        width: 80px;
        text-align: right;
        padding-top: 10px;
    }

    .el-descriptions-item__container {
        font-size: 15px;
    }

    .el-descriptions-item__content {
        width: 70%;
        border-bottom: 1px solid #b0b0b0;
        padding: 10px 0 5px 10px;
        font-weight: 600;
    }

    .el-descriptions {
        padding-left: 35px;
    }

    .lxdz {
        .el-descriptions-item__content {
            width: 60%;
        }
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar {
        width: 144px;
        height: 192px;
        display: block;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 144px;
        height: 192px;
        line-height: 192px;
        text-align: center;
    }

    .el-step__head.is-process,
    .el-step__title.is-process {
        color: orange;
        border-color: orange;
    }

    .title_l {
        float: left;
        margin-right: 20px;
        width: 240px;
        text-align: right;
    }

    .attrList-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }

    .attrList_avatar {
        width: 200px;
        height: 100px;
        display: block;
    }

    .previewImg {
        .el-dialog__header {
            display: none;
        }

        .el-dialog__body {
            padding: 0;
        }

        .el-dialog__footer {
            display: none;
        }
    }

    .payDialog {
        .spanTitle {
            display: inline-block;
            width: 75px;
            text-align: right;
        }

        .el-col {
            line-height: 3em;

            span {
                &.money {
                    color: red;
                }

                &:nth-child(2) {
                    margin-left: 2em;
                }
            }

            .typeBox {
                span {
                    line-height: 50px;
                    vertical-align: top;
                    display: inline-block;
                }

                img {
                    margin-left: 2em;
                    padding: 10px;
                    border: 1px solid transparent;

                    &.selected {
                        border-color: lightgrey;
                        box-shadow: 0 0 1px grey inset;
                        border-radius: 10px;
                    }

                }
            }

        }

        p.tip {
            margin-bottom: 3em;
        }

        .payInnerDialog {}
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/studentReport.vue